import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { coins } from "../../../constants/constants";
import { useUser } from "../../../context/user-context";
import useAuthAxios from "../../../utils/baseAxios";
import PortionAmount from "../../../components/PortionAmount";
import { formatAmount } from "../../../utils/formatTime";
import { RiSearchLine } from "react-icons/ri";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../constants/api";
import ClipLoader from "react-spinners/ClipLoader";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

const SendToDeexTag = ({
  setOpenWithdrawDeex,
  setOpenWithdraw,
  setOpenWithdrawDeexPreview,
  selectedCoinObjj,
  openWithdrawDeexPreview,
  setSelectedCoinObj,
  setAmount,
  selectedUser,
  selectedCoinObj,
  amount,
  setSelectedUser,
}: any) => {
  const axiosInstance = useAuthAxios();

  const { userDetails } = useUser();
  const [coinBalancee, setCoinBalancee] = useState<number | null>(null);
  const walletBalances = userDetails?.user.deexWalletBalances;
  const [disabled, setDisabled] = useState<boolean>(false);
  const [openSearch, setOpenSearch] = useState<boolean>(false);
  const [usersQuery, setUsersQuery] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const debouncedSearchValue = useDebouncedValue(searchValue, 300);
  // Initialize recent searches from localStorage
  // useEffect(() => {
  //   const storedSearches = localStorage.getItem("recentSearches");
  //   if (storedSearches) {
  //     setRecentSearches(JSON.parse(storedSearches));
  //   }
  // }, []);

  // Update recent searches in state and localStorage
  // const updateRecentSearches = (user: any) => {
  //   const updatedSearches = [
  //     user,
  //     ...recentSearches.filter((u) => u?.profile?._id !== user?.profile?._id),
  //   ].slice(0, 5); // Keep only the 5 most recent searches

  //   setRecentSearches(updatedSearches);
  //   localStorage.setItem("recentSearches", JSON.stringify(updatedSearches));
  // };

  // // Remove a recent search item
  // const removeRecentSearch = (userId: string) => {
  //   const updatedSearches = recentSearches.filter(
  //     (user) => user?.profile?._id !== userId
  //   );
  //   setRecentSearches(updatedSearches);
  //   localStorage.setItem("recentSearches", JSON.stringify(updatedSearches));
  // };

  // Handle empty search state

  // Fetch user tags based on debounced search value
  const getUserTags = async () => {
    const response = await axiosInstance.get(
      API.getDeexTags(debouncedSearchValue)
    );
    return response.data;
  };

  const {
    data: userTags,
    error: userTagsError,
    isFetching: loadingUserTags,
  } = useQuery({
    queryKey: ["get-deex-users", debouncedSearchValue],
    queryFn: getUserTags,
    retry: 1,
    enabled: !!debouncedSearchValue,
  });

  // Show error toast if the query fails
  useEffect(() => {
    if (userTagsError) {
      const newError = userTagsError as any;
      toast.error(newError?.message || newError?.data?.message);
    }
  }, [userTagsError]);

  // Debounce search value changes
  // useEffect(() => {
  //   const debounceTimer = setTimeout(() => {
  //     if (searchValue) {
  //       updateRecentSearches(searchValue); // Save to recent searches
  //     } else {
  //       handleEmptySearch();
  //     }
  //   }, 600);

  //   return () => clearTimeout(debounceTimer); // Cleanup timer
  // }, [searchValue]);
  // Handle new user tags data
  useEffect(() => {
    if (userTags) {
      setUsersQuery(userTags?.data?.users);
    }
  }, [userTags]);
  const highlightText = (text: string, highlight: string) => {
    if (!highlight.trim()) {
      return text;
    }
    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="font-bold text-[15px] font-sora">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const selectedAbbrLC = e.target.value.toLowerCase();
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
    setSelectedCoinObj(coin);
    const coinBalance = walletBalances[selectedAbbrLC];

    if (coinBalance !== undefined) {
      setCoinBalancee(coinBalance);
      // Here, you can display the balance in the UI, like updating state
    } else {
    }
  };
  useEffect(() => {
    if (selectedCoinObjj) {
      setSelectedCoinObj(selectedCoinObjj); // Set pre-selected coin
      const selectedAbbr = selectedCoinObjj?.abbr;
      const selectedAbbrLC = selectedCoinObjj?.abbr.toLowerCase();
      const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
      setSelectedCoinObj(coin);
      const coinBalance = walletBalances[selectedAbbrLC];

      if (coinBalance !== undefined) {
        setCoinBalancee(coinBalance);
        // Here, you can display the balance in the UI, like updating state
      } else {
      }
    }
  }, [selectedCoinObjj]);

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };

  useEffect(() => {
    if (!selectedCoinObj?.abbr || !amount || !selectedUser) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [amount, coinBalancee, selectedCoinObj?.abbr, selectedUser]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdrawDeex(false);
              setOpenWithdraw(true);
              setSelectedUser(null);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className=" text-gray-800 dark:text-gray-200 text-[16px]" />
          </button>
          <h4 className="text-gray-900  dark:text-gray-100 font-sora font-semibold text-[20px]">
            Send to Deex user
          </h4>
        </div>
        {/* {recentSearches?.length >= 1 && (
          <div className="grid grid-cols-4 gap-2 mt-8">
            {recentSearches?.map((user: any, index: any) => (
              <div
                key={index}
                onClick={() => setSelectedUser(user)}
                className="flex flex-col justify-center  items-center cursor-pointer"
              >
                <div className="flex justify-center items-center bg-[#D4EBFD] font-sora font-medium text-secondary_button text-[18px] h-[40px] w-[40px] rounded-full">
                  {user?.profile?.firstName.charAt(0)}
                  {user?.profile?.lastName.charAt(0)}
                </div>
                {user?.profile?.username && (
                  <h4 className="text-gray-500 dark:text-gray-400 text-center mt-1 text-[13px]">
                    @{user?.profile?.username}
                  </h4>
                )}
              </div>
            ))}
          </div>
        )} */}
        <div className="w-full mt-4">
          <div className="w-full pt-2 pb-4 border-b border-b-gray-200 dark:border-gray-600">
            <div className="flex justify-between gap-4 items-center">
              <div className="w-full m">
                <h4 className="text-[15px] text-gray-800 dark:text-gray-200">
                  Amount
                </h4>
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={handleChange}
                    className="text-gray-600 dark:text-gray-400 w-full spin-button-none bg-transparent text-[13px] text-left outline-none"
                  />
                  <h4 className="text-[13px] text-secondary_button">
                    {selectedCoinObj?.abbr}
                  </h4>
                </div>
              </div>
            </div>
            <div className="flex mt-3 justify-between items-center">
              {coinBalancee !== null && coinBalancee !== undefined && (
                <h4 className="text-center mt-2 text-[11px] xs:text-[13px] font-medium text-gray-700 dark:text-gray-300">
                  Balance:
                  <span className="text-green-700">
                    {formatAmount(coinBalancee)} {selectedCoinObj?.abbr || ""}
                  </span>
                </h4>
              )}
              <PortionAmount setAmount={setAmount} coinBalance={coinBalancee} />
            </div>
          </div>
          <div className="mt-6">
            <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-start items-center">
              <div className="flex justify-center items-center  w-[20px] h-[20px] rounded-full">
                <img
                  src={selectedCoinObj?.logo ? selectedCoinObj?.logo : ""}
                  className="w-full h-full bg-cover"
                  alt=""
                />
              </div>
              <select
                value={selectedCoinObj?.abbr || ""}
                onChange={handleCoinChange}
                className="outline-none bg-transparent w-full text-[14px] text-gray-800 dark:text-gray-200"
              >
                <option value="" disabled>
                  Select a coin
                </option>
                {coins.map((coin: any, index: any) => (
                  <option key={index} value={coin.abbr}>
                    {coin.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="w-full mt-6 relative">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Deex Tag
            </h4>

            <div
              onClick={() => {
                setOpenSearch((prev) => !prev);
              }}
              className="flex justify-start cursor-pointer  items-center text-[13px] mt-2 w-full text-gray-700 dark:text-gray-300   border bg-transparent border-gray-300 dark:border-gray-600 rounded-xl px-4 h-[52px]"
            >
              {selectedUser
                ? `@${
                    selectedUser?.profile?.username
                      ? selectedUser?.profile?.username
                      : `${selectedUser?.profile?.firstName} ${selectedUser?.profile?.lastName}`
                  }`
                : "Enter deex tag / Email address"}
            </div>
            {selectedUser && selectedUser?.profile?.username && (
              <h4 className="text-gray-600 dark:text-gray-400 font-medium mt-1 text-[12px]">
                {selectedUser?.profile?.firstName}{" "}
                {selectedUser?.profile?.lastName}
              </h4>
            )}
            {openSearch && (
              <div className="absolute z-50 shadow-md rounded-xl w-full mt-2 p-3 h-[350px] border dark:bg-gray-800 border-gray-200 dark:border-gray-600 overflow-auto bg-[#F7F8F9] ">
                <div className="flex items-center  rounded-xl py-4 gap-2 mb-2 px-4 shadow-md border   justify-start  border-gray-600 ">
                  <RiSearchLine className="h-5 w-5 text-gray-400" />
                  <input
                    type="search"
                    placeholder="Search Deex-tag or email"
                    value={searchValue}
                    onChange={(e) =>
                      setSearchValue(e.target.value.toLowerCase())
                    }
                    className="w-full bg-transparent text-[13px] lgss:text-[14px]  text-gray-700 dark:text-gray-300 placeholder:dark:text-gray-300  focus:outline-none"
                    aria-label="Search"
                  />
                </div>
                {loadingUserTags ? (
                  <div className="w-full flex justify-center items-center mt-6">
                    <ClipLoader color="#0B84CB" size={40} />
                  </div>
                ) : (
                  <div className="w-full">
                    {usersQuery.length >= 1 ? (
                      <div className="w-full">
                        {usersQuery.map((user: any, index: any) => (
                          <div
                            key={index}
                            onClick={() => {
                              setSelectedUser(user);
                              // updateRecentSearches(user);
                              setOpenSearch(false);
                            }}
                            className="flex justify-start mt-3 cursor-pointer items-center gap-2 px-4 bg-white dark:bg-gray-800 py-3 rounded-xl"
                          >
                            <div className="flex justify-center items-center bg-[#D4EBFD] font-sora font-medium text-secondary_button text-[18px] h-[40px] w-[40px] rounded-full">
                              {user?.profile.firstName.charAt(0)}
                              {user?.profile.lastName.charAt(0)}
                            </div>
                            <div>
                              <h4 className="text-[13px] text-secondary_button font-medium">
                                {highlightText(
                                  `${user?.profile.firstName}
                                ${user?.profile.lastName}`,
                                  searchValue
                                )}
                              </h4>
                              {user?.profile.username && (
                                <h4 className="text-gray-500 dark:text-gray-400 text-[13px]">
                                  @
                                  {highlightText(
                                    `${user?.profile.username}`,
                                    searchValue
                                  )}
                                </h4>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <h4 className="text-gray-500 dark:text-gray-400 text-[13px] text-center mt-2">
                        No user matches the query "{searchValue}"
                      </h4>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="mt-10">
            <div className="flex justify-between items-center">
              <h4 className="text-[13px] text-secondary_button">Fee</h4>
              <h4 className="text-[13px] text-gray-900 dark:text-gray-100">
                Free
              </h4>
            </div>
            <div className="flex justify-between items-center mt-2">
              <h4 className="text-[13px] text-secondary_button">
                Amount to send
              </h4>
              <h4 className="text-[13px] text-gray-900 dark:text-gray-100">
                {amount ? formatAmount(amount) : "----"} {selectedCoinObj?.abbr}
              </h4>
            </div>
            <button
              onClick={() => {
                setOpenWithdrawDeex(false);
                setOpenWithdrawDeexPreview(true);
              }}
              disabled={disabled}
              className={
                disabled
                  ? "mt-8 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl"
                  : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
              }
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendToDeexTag;
